var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.DRAW_MODE.toolsAreVisible
    ? _c(
        "lbs-dialog",
        {
          staticClass:
            "us-annotations-ui us-color-picker-target lbs-scope-container",
          attrs: { title: _vm.$t(_vm.ownerI18nKey) },
          on: { close: _vm.HIDE_DRAWING_TOOLS }
        },
        [
          _c("div", { attrs: { slot: "body" }, slot: "body" }, [
            _c(
              "section",
              { staticClass: "annotation-drawing-modes" },
              _vm._l(_vm.DRAW_MODE.drawModes, function(mode) {
                var _obj
                return _c("b-btn", {
                  key: mode.id,
                  class: ((_obj = {}),
                  (_obj["annotation-icon-" + mode.name] = true),
                  (_obj.active = mode === _vm.DRAW_MODE.drawMode),
                  _obj),
                  attrs: {
                    disabled: !mode.enabled,
                    title: _vm.$t("annotations.tooltips." + mode.name)
                  },
                  on: {
                    click: function($event) {
                      return _vm.START_DRAW_MODE(mode)
                    }
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "annotation-tools" },
              _vm._l(_vm.tools, function(tool) {
                return _c("b-btn", {
                  key: tool,
                  class: "annotation-icon-" + tool,
                  attrs: {
                    disabled: !_vm.toolIsEnabled(tool),
                    title: _vm.$t("annotations.tooltips." + tool)
                  },
                  on: {
                    click: function($event) {
                      return _vm.runTool(tool, $event)
                    }
                  }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "section",
              _vm._l(_vm.navs, function(nav) {
                return _c("b-btn", {
                  key: nav,
                  class: "annotation-icon-" + nav,
                  attrs: {
                    disabled: !_vm.hasAnnotations,
                    title: _vm.$t("annotations.tooltips." + nav)
                  },
                  on: {
                    click: function($event) {
                      return _vm.MOVE_REGION_CURSOR(nav)
                    }
                  }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/uScope/js/extensions/annotations/annotations-ui/AnnotationsPanel.vue?vue&type=template&id=60d2c81b&scoped=true&
// module id = 387
// module chunks = 0